import styles from '../../../MyAccount/Sections/LiveGameSection/Sections/LiveChat/liveChat.module.css'

const chatInputFieldStyle = {
    container: `flex flex-col gap-[15px] sm:gap-[20px] items-center justify-center absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 rounded-[8px] bg-transparent backdrop-blur-md text-white p-[18px] pt-[40px]
                min-w-[90%] max-w-[400px] 
                sm:p-[25px] sm:min-w-[unset]
    `,
    closeIcon: `absolute top-1 right-4`,
    heading: `text-[20px] font-[600] leading-[13px] py-[8px]
              sm:text-[24px]
    `,
    sendButton: `min-w-[38px] min-h-[38px] max-w-[38px] max-h-[38px] flex items-center justify-center p-2 bg-themeShadowColor rounded-[10px] ${styles.sendButton}
                    screen-500:bg-themeColor screen-500:rounded-full
        `,
}

export { chatInputFieldStyle }